import { LoaderCircle } from "lucide-react";

export default function ChatPanelLoading() {
  return (
    <div
      className="text-muted-foreground bg-muted/50 flex h-full min-h-64 flex-1 flex-col items-center justify-center gap-3 text-sm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoaderCircle
        className="h-6 w-6 motion-safe:animate-spin"
        aria-hidden="true"
      />
      メッセージを読み込み中…
    </div>
  );
}
